export default function minutes(value) {
  if (!Number.isInteger(value)) {
    return value;
  }

  let hours = Math.floor(value / 3600);
  let minutes = Math.floor((value - (hours * 3600)) / 60);
  let seconds = value - (hours * 3600) - (minutes * 60);

  if (minutes < 10) {minutes = '0' + minutes;}
  if (seconds < 10) {seconds = '0' + seconds;}
  let time = `${minutes}:${seconds}`;

  if (hours) {
    if (hours < 10) {hours = '0' + hours;}
    time = `${hours}:${time}`;
  }

  return time;

}


// WEBPACK FOOTER //
// ./src/modules/dro/filters/minutes.js